import { Tabs as ShadcnTabs, TabsList, TabsTrigger } from "@altimateai/lego";

interface Props {
  items: { label: string; value: string }[];
  selectedTab: string;
  onTabSelect: (value: string) => void;
  pills?: boolean;
  className?: string;
}

const Tabs = ({ items, selectedTab, onTabSelect, pills: _pills = true, className, ...rest }: Props) => {
  return (
    <ShadcnTabs value={selectedTab} onValueChange={onTabSelect} {...rest}>
      <TabsList className={className}>
        {items.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value}>
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </ShadcnTabs>
  );
};

export default Tabs;
